/* tslint:disable: max-classes-per-file */
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import {
  IBeneficiarioVitalicio,
  IColumnsDataTable,
} from 'src/app/shared/Entities/entities';
import { Event } from 'src/app/shared/enums/insights/event';
import { PipeEnum } from 'src/app/shared/helpers/constants';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { PersonService } from 'src/app/shared/services/person.service';

@Component({
  selector: 'app-data-beneficiario-modal',
  templateUrl: 'data-beneficiario-modal.component.html',
  styleUrls: ['data-beneficiario-modal.component.sass'],
})
export class DataBeneficiarioModalComponent {
  public dialogRef: MatDialogRef<DataBeneficiarioModalComponent>;
  constructor(@Inject(MAT_DIALOG_DATA) public data: IBeneficiarioVitalicio) {}

  onClose(): void {
    this.dialogRef.close();
  }
  formatDate(d) {
    return moment(d).format('DD-MM-YYYY');
  }
}
@Component({
  selector: 'app-card-beneficiarios',
  templateUrl: './card-beneficiarios.component.html',
  styleUrls: ['./card-beneficiarios.component.sass'],
})
export class CardBeneficiariosComponent implements OnInit, OnDestroy {
  @Input() idPoliza: string;
  @Input() tipo: string;
  loading = false;
  error = false;
  beneficiarios: IBeneficiarioVitalicio[] = [];
  private subscriptions: Subscription[] = [];
  icon_type: string;

  displayedColumns = [
    {
      ColumnDef: 'NombreCompleto',
      ColumnName: 'Nombre Beneficiario',
    },
    {
      ColumnDef: 'Rut',
      ColumnName: 'RUT',
    },
    {
      ColumnDef: 'FechaNacimientoUI',
      ColumnName: 'FECHA NACIMIENTO',
    },
    {
      ColumnDef: 'Edad',
      ColumnName: 'EDAD',
      Pipe: PipeEnum.edadPipe,
    },
    {
      ColumnDef: 'Parentesco',
      ColumnName: 'PARENTESCO',
    },
    {
      ColumnDef: 'Situacion',
      ColumnName: 'SITUACIÓN INVALIDEZ',
    },
  ] as IColumnsDataTable[];

  constructor(
    private personService: PersonService, 
    public modal: MatDialog,
    private appInsightsService: AppInsightsService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.error = false;
    const loadSubscription = this.personService
      .getBeneficiariosVitalicio(this.idPoliza, this.tipo)
      .subscribe(
        data => {
          this.loading = false;
          if (!data) {
            return;
          }
          this.beneficiarios = data.map(d => {
            d.NombreCompleto = `${d.Nombre} ${d.ApellidoPaterno} ${d.ApellidoMaterno}`;
            return d;
          });
        },
        error => {
          this.loading = false;
          this.error = true;
        }
      );

    this.subscriptions.push(loadSubscription);
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onIconClick(item) {
    this.appInsightsService.trackEvent(Event.pidsIcShowDetailBeneficiary);

    const getBeneficiarioSub = this.personService
      .getBeneficiarioVitalicio(this.idPoliza, this.tipo)
      .subscribe(data => {
        const dialogRef = this.modal.open(DataBeneficiarioModalComponent, {
          data: {
            ...item.item,
          } as IBeneficiarioVitalicio,
          height: '19.75rem',
          width: '43.75rem',
          disableClose: true,
          panelClass: 'custom-dialog',
        });
        dialogRef.afterClosed().subscribe(result => {
          // this.res = result;
        });
      });

    this.subscriptions.push(getBeneficiarioSub);
  }

  expandChange() {
    this.appInsightsService.trackEvent(Event.pidsAccShowBeneficiaries);
  }
}
